var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dal-slider-audio"},[_c('button',{staticClass:"button",on:{"click":_vm.toggle}},[_c('svg',{staticClass:"svg",attrs:{"role":"img","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"circle-foreground",class:{
          'active': _vm.progress > 0
        },style:({
          'stroke-dasharray': (_vm.progress + "px 125px")
        })})]),_vm._v(" "),(!_vm.paused)?_c('AudioPauseIcon',{staticClass:"pause"}):_c('AudioIcon')],1),_vm._v(" "),_c('audio',{ref:"audio",staticClass:"audio",attrs:{"src":_vm.src},on:{"play":_vm.trackAudio,"playing":_vm.onPlay,"pause":_vm.onPause,"ended":_vm.onEnd,"timeupdate":_vm.onTimeupdate}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93be288a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dal/DalSliderAudio.vue
// module id = null
// module chunks = 